module.exports = __webpack_public_path__ + "img/marina_rdl.7b2a6754.webp";